export enum UserLogsTableLayoutContent {
  json,
  table,
}